// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:54:34

export default {
  "id": "mineblocks-3d-maze",
  "slug": "mineblocks-3d-maze",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1ecbfc918b234216bc599edf5efb9b55-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1ecbfc918b234216bc599edf5efb9b55/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "MineBlocks 3D Maze",
      "description": "MineBlocks 3D Maze: A Mind-Bending Adventure in a Blocky World! Get ready to step into a world of puzzles and creativity with MineBlocks 3D Maze—an incredible game that’s perfect for kids and adults alike. If you’re a fan of brain-teasers and enjoy a good challenge, this 3D puzzle game is exactly what you need. It’s all about strategy, logic, and a little bit of muscle (virtual, of course)!  Push the blocks strategically to guide them onto the altars scattered across the level.",
      "instructions": "Arrow or WASD keys to move the player.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "3d",
        "maze",
        "minecraft",
        "skill",
        "thinking"
      ]
    },
    "zh-CN": {
      "title": "MineBlocks 3D迷阵",
      "description": "MineBlocks 3D迷宫：方块世界的脑洞大冒险！准备好踏入一个充满谜题和创造力的世界吧，MineBlocks 3D迷宫是一款适合儿童和成人的精彩游戏。如果你是喜欢智力游戏和挑战的人，这款3D益智游戏正是你所需要的。它关乎策略、逻辑，还有一点点（虚拟的）力量！巧妙推动方块，引导它们落在关卡中散布的祭坛上。",
      "instructions": "使用箭头键或WASD键移动玩家。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "三维",
        "迷宫",
        "我的世界",
        "技能",
        "思考"
      ]
    },
    "zh-TW": {
      "title": "地心迷宮3D",
      "description": "MineBlocks 3D Maze：一個讓思維翻轉的積木世界冒險！準備進入一個充滿謎題與創意的世界，與MineBlocks 3D Maze一同體驗這款適合大人小孩的精彩遊戲。如果你是愛好腦筋急轉彎和享受挑戰的人，這款3D拼圖遊戲正是你需要的！這個遊戲關乎策略、邏輯，還有一點點（虛擬的）體力！巧妙地推動積木，將它們引導到等級中散布的祭壇上。",
      "instructions": "箭頭鍵或 WASD 鍵移動玩家。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "3D",
        "迷宮",
        "當 Minecraft",
        "技巧",
        "思考"
      ]
    },
    "zh-HK": {
      "title": "礦石迷宮3D",
      "description": "MineBlocks 3D Maze：一個令人搖頭歎息的積木世界冒險！準備進入一個充滿謎題和創意的世界吧，MineBlocks 3D Maze 是一款適合兒童和成人一齊遊玩的出色遊戲。如果你是喜歡腦筋急轉彎和享受挑戰的人，這款 3D 遊戲正是你需要的！這是一款關於策略、邏輯和一點點肌肉（當然是虛擬的！）的遊戲！巧妙地推動積木，引導它們落在等級中分佈的祭壇上。",
      "instructions": "箭頭鍵或 WASD 鍵控制角色移動。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "3D",
        "迷宮",
        "迷你地牢",
        "技巧",
        "思考"
      ]
    },
    "ja": {
      "title": "マインブロックス 3D マジー",
      "description": "MineBlocks 3D迷宮：ブロックの世界で心を躍らせる謎解きアドベンチャー！MineBlocks 3D迷宮で、パズルと創造性に満ちた世界へと踏み出してみてください。脳を鍛えるパズルや楽しい挑戦を好む人に最適な驚異的なゲームです。戦略、論理、そして少しの筋力（もちろん仮想のもの）が全てです！ブロックを戦略的に押し進めて、レベル内に散らばる祭壇に導いてください。",
      "instructions": "プレイヤーを移動させるには、矢印キーやWASDキーを使用してください。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "3D",
        "迷路",
        "マイクラ",
        "スキル",
        "思考"
      ]
    },
    "ko": {
      "title": "마인블록 3D 마azes",
      "description": "mineBlocks 3D 맵: 블록 세계의 기이한 모험! MineBlocks 3D 맵으로 이끌려 패ازル과 창의성의 세계로 가보세요. 자녀와 성인 모두에게 적합한 이 장대한 게임은 지적 장애물의 팬이며 좋은 도전을 좋아한다면, 이 3D 패자게임이 바로 필요합니다. 전략, 논리, 그리고 조금의 근력(가상적으로만)이 전부입니다! 블록을 전략적으로 밀어 배경 전체에 퍼진 제단 위로 이동시키세요.",
      "instructions": "사거리 또는 WASD 키로 플레이어 이동.",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "3D",
        "루비",
        "마인크래프트",
        "기술",
        "사고력"
      ]
    },
    "fr": {
      "title": "MinesBlocks Labyrinthe 3D",
      "description": "MineBlocks 3D Maze : Une aventure éblouissante dans un monde en blocs ! Préparez-vous à plonger dans un monde de puzzles et de créativité avec MineBlocks 3D Maze — un jeu incroyable parfaitement adapté aux enfants et aux adultes. Si vous êtes fan des énigmes et aimez vous défier, ce jeu de puzzle en 3D est exactement ce qu'il vous faut. Il s'agit de stratégie, de logique et un peu de muscle (virtuel, bien sûr) ! Déplacez les blocs stratégiquement pour les guider vers les autels disséminés sur le niveau.",
      "instructions": "Flèches ou touches WASD pour déplacer le joueur.",
      "genres": [
        "Décontracté",
        "Puzzle"
      ],
      "tags": [
        "3D",
        "labyrinthe",
        "Minecraft",
        "compétence",
        "pensée"
      ]
    }
  }
};
